import ComponentBootstrap from 'app/bootstrap/ComponentBootstrap'
import PluginBootstrap from 'app/bootstrap/PluginBootstrap'
import ApolloBootstrap from 'app/bootstrap/ApolloBootstrap'
import RouterBootstrap from 'app/bootstrap/RouterBootstrap'
import ServiceBootstrap from 'app/bootstrap/ServiceBootstrap'
import FilterBootstrap from 'app/bootstrap/FilterBootstrap'
import I18nBootstrap from 'app/bootstrap/I18nBootstrap'
import AclBootstrap from "app/bootstrap/AclBootstrap";

export default [

    new ServiceBootstrap,
    new AclBootstrap,
    new RouterBootstrap,
    new PluginBootstrap,
    new ApolloBootstrap,
    new ComponentBootstrap,
    new FilterBootstrap,
    new I18nBootstrap
];